import React from 'react';
import SitemapUrls from './SitemapUrls';
import { OuterContainer, TopHeading } from './styled';

function SitemapComponent(props) {
  const { siteMapUrls } = props;
  siteMapUrls.category_urls = getAllCategories(
    siteMapUrls?.categoryNavBarData,
    [],
  );

  function getAllCategories(categoriesData, currentData) {
    categoriesData.map((data) => {
      if (data?.subCategories) {
        currentData = getAllCategories(data?.subCategories, currentData);
        currentData.push(data);
      } else {
        currentData.push(data);
        return currentData;
      }
    });
    return currentData;
  }

  return (
    <OuterContainer>
      <TopHeading>Sitemap</TopHeading>
      <SitemapUrls heading="Category Url's" data={siteMapUrls?.category_urls} />
      {/* <SitemapUrls
                heading="Health Url's"
                data={siteMapUrls?.health_urls}
            /> */}
      {/* <SitemapUrls
                heading="Clinic Url's"
                data={siteMapUrls?.clinic_urls}
            /> */}
      <SitemapUrls heading="Other Url's" data={siteMapUrls?.static_pages} />

      {/* <SitemapUrls
                heading="Product Url's"
                data={siteMapUrls?.product_urls}
            />
            <SitemapUrls
                heading="Article Url's"
                data={siteMapUrls?.article_urls}
            />
            <SitemapUrls heading="Topic Url's" data={siteMapUrls?.topic_urls} />
            <SitemapUrls
                heading="Question Url's"
                data={siteMapUrls?.question_urls}
            /> */}
    </OuterContainer>
  );
}

export default SitemapComponent;
